<template>
  <div class="general">
    <Head :title="$ml.get(`General Information`)"/>
    <div>
      <!-- TO DO: повстовлять функции для текста -->
      <app-text-input
        :label="$ml.get(`Fertilizer name`)"
        v-model="general.name"
        type="text"
        required
      />
      <app-text-input
        :label="$ml.get(`Manufacturer`)+'/'+$ml.get('Country')"
        v-model="general.manufacturer"
        type="text"
      />

      <app-sel
        key-name="id"
        label-name="name"
        :label="$ml.get(`State`)"
        :items="states"
        v-model="general.stateId"
        required
      >
        <template v-slot="{ items }">
          <app-sel-opt
            v-for="item in items"
            :value="item"
            :key="item.id"
          >
            <template v-if="$ml.get(item.name)">{{ $ml.get(item.name) }}</template>
            <template v-else>{{ item.name }}</template>
          </app-sel-opt>
        </template>
      </app-sel>

      <app-text-input
        :label="$ml.get(`Min temperature`)"
        v-model="general.data.MinimumTemp"
        type="number"
        hint="C"
        :min="$store.getters['unit/convert']('C', 0)"
        required
      />

      <template v-if="$store.getters['fertilizers/popup/isNew']">
        <app-text-input
          v-if="general.stateId == 5 || general.stateId == 6"
          :label="$ml.get(`Maximum Availability`)"
          v-model="general.maximumAvailability"
          type="number"
          hint="kg"
          min="0"
        />
      </template>
      <template v-else>
        <app-text-input
          v-if="general.stateId == 5 || general.stateId == 6"
          :label="$ml.get(`Maximum Availability`)"
          v-model="general.data.maximumAvailability"
          type="number"
          hint="kg"
          min="0"
        />
      </template>


      <template>

        <app-text-input
          v-if="state != 'acid'"
          :label="$ml.get(`pH(1g/L distilled water)`)"
          v-model="general.data.PH"
          type="number"
          hint=""
          min="0"
          max="14"
        />
        <app-text-input
          v-if="general.stateId == 3 || general.stateId == 4"
          :label="$ml.get(`Density`)"
          v-model="general.data.SpecificWeight"
          type="number"
          hint="kg/L"
          min="0"
          :max="state == 'acid' ? 5 : 2"
          required
        />
        <app-text-input
          v-if="state == 'acid'"
          :label="$ml.get(`Molecular Weight`)"
          v-model="general.data.MolecularWeight"
          type="number"
          hint="g/mol"
          min="0"
          max="250"
          required
        />
        <app-text-input
          v-if="state == 'acid'"
          :label="$ml.get(`Number Of H`)"
          v-model="general.data.NumberOfH"
          type="number"
          min="0"
          required
        />

      </template>


    </div>

    <Flags :general="general"/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Flags from './Flags.vue';
import Head from './helps/Head.vue'

export default {
  props: {
    general: Object,
    // value: {
    //   required: true,
    // },
  },
  // data() {
  //   return {
  //     state: null,
  //   }
  // },
  components: {
    Flags,
    Head
  },
  computed: {
    ...mapGetters({
      states: 'fertilizers/popup/states',
      state: 'fertilizers/popup/state',
    })
  },
  watch: {
    'general.data.SpecificWeight': function (val) {
    },
    'general.stateId': function(val) {
      this.$store.commit('fertilizers/popup/setState', val);
    }
  }
}
</script>

<style lang="scss" scoped>
  .general {
    width: 100%;

    > div:not(.head) {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      flex-wrap: wrap;
      margin-right: -16px;
      margin-left: -16px;


      &:nth-child(2) {
        margin-top: 25px;

        @media (max-width: 768px) {
          justify-content: center;
          > div {
            margin: 0 0 32px 0;
            width: 100%;
          }
        }
      }

      > div {
        width: calc(33.3% - 32px);
        min-width: 200px;
        margin: 16px;

        &:not(.app-sel) {
          padding: 1px;
        }
      }
    }
  }
</style>
